export enum DispatchedAmountType {
    Actual = 1,
    Calculated = 2
}
